import { isAxiosError } from "axios"

import axiosInstance from "../api.axiosInstance"
import type { BatterySavingsReportAvailabilityDto } from "../dto/battery-savings-report.dto"

const reportPath = (proposalId: string): string =>
  `/battery-proposal/v2/${proposalId}/savings-report`

export const batterySavingsReportService = {
  async availability(
    proposalId: string,
  ): Promise<BatterySavingsReportAvailabilityDto> {
    const response =
      await axiosInstance.get<BatterySavingsReportAvailabilityDto>(
        reportPath(proposalId),
      )
    return response.data
  },
  async download(proposalId: string): Promise<{ pdf: Blob; filename: string }> {
    try {
      const response = await axiosInstance.post<ArrayBuffer>(
        `${reportPath(proposalId)}/export`,
        undefined,
        {
          responseType: `arraybuffer`,
          timeout: 150_000,
        },
      )
      const disposition = String(response.headers[`content-disposition`] ?? ``)
      const filename = /filename="([^"]+)"/.exec(disposition)?.[1]
      return {
        pdf: new Blob([response.data], { type: `application/pdf` }),
        filename: filename ?? `battery-savings-report-${proposalId}.pdf`,
      }
    } catch (error) {
      if (isAxiosError(error) && error.response?.data instanceof ArrayBuffer) {
        try {
          error.response.data = JSON.parse(
            new TextDecoder().decode(error.response.data),
          )
        } catch {
          // Preserve non-JSON failures for the retry message.
        }
      }
      throw error
    }
  },
}
